import { render } from "./link-to-advanced.vue?vue&type=template&id=669d4716"
import script from "./link-to-advanced.vue?vue&type=script&lang=js"
export * from "./link-to-advanced.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__